<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>
      <admin-footer></admin-footer>
      <div id="backtoTop" @click="scrollToTop()">
        <span class="fa fa-chevron-up"></span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TopNavbar from './TopNavbar.vue'
  import SideBar from '../ui/SideBar'
  import AdminFooter from './Footer.vue'
  import DashboardContent from './Content.vue'
  export default {
    name: 'Layout',
    components: {
      SideBar,
      TopNavbar,
      AdminFooter,
      DashboardContent
    },
    computed: {
      ...mapGetters([
        '$sidebar'
      ])
    },
    methods: {
      scrollToTop () {
        this.scroll = setInterval(this.scrollStep, 16.66)
      },
      scrollStep () {
        if (window.pageYOffset === 0) {
          clearInterval(this.scroll)
        }
        window.scroll(0, window.pageYOffset - 1000)
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/admin/Layout.vue